module.exports = __webpack_public_path__ + "fonts/icomoon.5b294c7.ttf";